module.exports = __webpack_public_path__ + "static/media/logo.abb405d9.svg";


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/assets/img/logo.svg
// module id = 864
// module chunks = 0